import { NewsWrapper } from "../../../../src/collections/news/News.style.js";
import smp from "../../../../src/collections/news/2021/2021-10-12-cncf-adopts-service-mesh-performance-standard-established-by-layer5/smp-in-meshery.png";
import * as React from 'react';
export default {
  NewsWrapper,
  smp,
  React
};